import React, { FC, Fragment } from 'react';
import { Props } from './HighlightedText.types';

const HighlightedText: FC<React.PropsWithChildren<Props>> = ({
    text,
    highlight
}) => {
    const parts = text.split(
        new RegExp(
            `(${highlight.replace(
                /[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi,
                ''
            )})`,
            'gi'
        )
    );
    // Every odd item should be strong
    return (
        <>
            {parts.map((p, idx) =>
                idx % 2 === 1 ? (
                    <strong key={`highlight-${idx}`}>{p}</strong>
                ) : (
                    <Fragment key={`text-${idx}`}>{p}</Fragment>
                )
            )}
        </>
    );
};

HighlightedText.displayName = 'HighlightedText';

export default HighlightedText;
